module.exports = __webpack_public_path__ + "img/base_data2.b97e0e80.png";